import { Modal } from "react-bootstrap";
import Styles from "./Confirmation.module.css";
import Loader from "../SharedComponents/Loader/Loader";
import cancelIcon from "../Assets/cross.png";

export const Confirmation = (props) => {
  return (
    <>
      <div className={Styles.parentContainer + " container-fluid"}>
        <div className="container">
          <Modal
            size="xs"
            show={props?.isOpen}
            onHide={props?.onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className={Styles.cancelImgParentContainer}>
                <div>
                  <p className="fontBold">Confirmation</p>
                </div>
                <div className={Styles.cancelImgContainer}>
                  <img
                    onClick={props.onHide}
                    src={cancelIcon}
                    alt="cancel"
                    className={Styles.cancelImg}
                  />
                </div>
              </div>
              <div className={Styles.container}>
                {props?.dataKey?.map((item) => (
                  <div className={Styles.contentAlignment} key={item.key}>
                    <p className={Styles.titleContainer}>{item?.key}</p>
                    <p className={Styles.colonContainer}>:</p>
                    <p className={Styles.valueContainer}>
                      {item?.isAmount ? <span>₹</span> : null}{" "}
                      {props?.data?.[item.attribute] || "-"}{" "}
                      {item?.ispercentage ? <span>%</span> : null}
                    </p>
                  </div>
                ))}
              </div>

              <div className={Styles.btnContainer}>
                <button onClick={props?.onHide} className={Styles.Resetbtn}>
                  Cancel
                </button>
                <button onClick={props?.onSucess} className={Styles.btn}>
                  Choose
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
